/**
 * Полномочия finance на фронте. Коды — те же, что в реестре сервера
 * (`app/core/modules/auth/permission/registry.py`); решает сервер, здесь только
 * не показываем то, в чём он откажет.
 */
import { useGetIdentity } from "@refinedev/core";

import type { CurrentUser } from "@/lib/providers";

export const STATEMENTS = "statements";
export const PNL = "pnl";
export const PNL_EDIT = "pnl_edit";
export const KASSA = "kassa";
export const KASSA_EDIT = "kassa_edit";
export const CONTROL = "control";
export const PAYROLL = "payroll";
export const PERSONAL_FINANCE = "personal_finance";
export const PERMISSIONS_EDIT = "permissions_edit";
export type PermissionCode =
  | typeof STATEMENTS
  | typeof PNL
  | typeof PNL_EDIT
  | typeof KASSA
  | typeof KASSA_EDIT
  | typeof CONTROL
  | typeof PAYROLL
  | typeof PERSONAL_FINANCE
  | typeof PERMISSIONS_EDIT;

export function has(user: CurrentUser | null | undefined, code: PermissionCode): boolean {
  return user?.permissions?.includes(code) ?? false;
}

/** Кто вошёл — единственный вход к `/api/me` на экранах. Свежесть — минуты:
 *  чужой 401 любого запроса всё равно уводит на вход через `authProvider.onError`. */
export function useIdentity() {
  return useGetIdentity<CurrentUser>({ queryOptions: { staleTime: 5 * 60_000 } });
}

/** Есть ли право. Ответ окончательный: каркас не рисует экран, пока личность не приехала. */
export function useCan(code: PermissionCode): boolean {
  const { data } = useIdentity();
  return has(data, code);
}
